import { useContext } from "react";
import { extractAssessmentName } from "../../../helpers/assessment-name";
import { convertPortalContextToLmsName } from "../../shared";
import { PortalControllerContext } from "../../context";
import { QuizWithProctoringOptions } from "./assessments-page-helper";
import { checkCompatibilityExtension, launchAssessmentHere } from "../../start-assessment";
import i18n from "../../../i18n";
import ModalPage from "../modal-page";
import BackBanner from "../back-banner";
import PageCard from "../page-card";
import ExtensionSetupInstructions from "../../../setup/components/ExtensionSetupInstructions";
import styles from "./install-extension-modal.module.css";
import Extension from "../../../images/portal/extension.svg?react";

export default function InstallExtensionModal({
	onClose,
	action,
	assessment,
}: {
	onClose: () => void;
	reason: "extension" | "managed-guest-session" | "incognito";
	action: "start" | "check-compatibility";
	assessment: QuizWithProctoringOptions;
}) {
	const { portalContext, userPlatformInfo, instituteSettings } = useContext(PortalControllerContext);

	return (
		<ModalPage>
			<BackBanner onBack={onClose}>{extractAssessmentName(assessment)}</BackBanner>
			<div className={styles.content}>
				<PageCard
					icon={<Extension />}
					title={i18n.t("portal.components.installExtensionModalTSX.title")}
					className={styles.pageCard}
				>
					<div className={styles.cardContent}>
						<ExtensionSetupInstructions
							lms={convertPortalContextToLmsName(portalContext)}
							requireManagedGuestSession={assessment.proctoringOptions?.isLockdown ?? false}
							checkIncognitoMode={assessment.proctoringOptions?.requiresIncognito ?? false}
							managedGuestSessionRequireIncognito={instituteSettings.managedGuestSessionRequireIncognito}
							platformInfo={userPlatformInfo}
							startAssessment={
								action === "start" ? () => launchAssessmentHere(portalContext, userPlatformInfo, assessment) : undefined
							}
							checkCompatibility={
								action === "check-compatibility"
									? () => checkCompatibilityExtension(portalContext, assessment)
									: undefined
							}
							courseId={portalContext.courseId}
						/>
					</div>
				</PageCard>
			</div>
		</ModalPage>
	);
}
